import { type AppDatabase } from '../db';
import type { Printer } from '../models';
import { BOOLEAN_VALUE } from '../types';

type PrinterInput = Omit<Printer, 'createdAt' | 'lastUsedAt'>;

export class PrinterService {
    constructor(private readonly db: AppDatabase) {
        this.db = db;
    }

    async getAll(searchTerm?: string) {
        const data = await this.db.printers.orderBy('createdAt').toArray();

        if (!searchTerm) {
            return data;
        }

        const searchLower = searchTerm.toLowerCase();

        return data.filter(({ name }) =>
            name.toLowerCase().includes(searchLower),
        );
    }

    async create(printer: PrinterInput) {
        return this.db.printers.add({
            ...printer,
            createdAt: new Date().toISOString(),
            lastUsedAt: null,
        });
    }

    async update(printer: PrinterInput) {
        return this.db.printers.update(printer.id, printer);
    }

    async getById(id: string) {
        return this.db.printers.where('id').equals(id).first();
    }

    async delete(id: string) {
        return this.db.printers.delete(id);
    }

    async getSalePrinters() {
        return this.db.printers
            .where('useAsSalePrinter')
            .equals(BOOLEAN_VALUE.TRUE)
            .toArray();
    }

    async getDocketPrinters() {
        return this.db.printers
            .where('useAsDocketPrinter')
            .equals(BOOLEAN_VALUE.TRUE)
            .toArray();
    }

    async getByDocketId(docketId: string) {
        return this.db.printers.where('docketIds').equals(docketId).toArray();
    }
}
